import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import {
  Box,
  Chip as MuiChip,
  Divider as MuiDivider,
  Grid,
  IconButton,
  Paper as MuiPaper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  Toolbar,
  Tooltip,
  Typography,
  CircularProgress,
  FormControlLabel,
  Switch,
  Breadcrumbs,
} from "@material-ui/core";

import { green, orange, red } from "@material-ui/core/colors";
import {
  RemoveRedEye as RemoveRedEyeIcon,
  Delete as DeleteIcon,
  Edit as EditIcon,
} from "@material-ui/icons";
import { spacing } from "@material-ui/system";
import {
  HighlightProduct,
  getProducts,
} from "../NetworkCalls/Products/ServerReq";
import ButtonIconComponent from "../Components/ButtonIcons";
import SearchBar from "../Components/SearchBar";
import { ExportToExcel } from "../Components/ExportToExcel";
import ImportExcel from "../Components/ImportExcel";
import SwitchCheck from "../Components/SwitchCheck";
import TimeRangeField from "../Components/TimeRangeField";
import { GetAllDataNestedCollections, UpdateAllDocsNestedCollections, UpdateSingleDocNEstedCollections } from "../NetworkCalls/Admin/ServerReq";
const Divider = styled(MuiDivider)(spacing);
const Paper = styled(MuiPaper)(spacing);
const Chip = styled(MuiChip)`
  ${spacing};
  background: ${(props) => props.shipped && green[500]};
  background: ${(props) => props.processing && orange[700]};
  background: ${(props) => props.cancelled && red[500]};
  color: #fff;
`;

const Spacer = styled.div`
  flex: 1 1 100%;
`;

const ToolbarTitle = styled.div`
  min-width: 150px;
`;

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const headCells = [
  { id: "id", alignment: "left", label: "S.No" },
  { id: "name", alignment: "left", label: "Restaurant Name" },
  { id: "address", alignment: "left", label: "Address" },
  { id: "status", alignment: "left", label: "Status" },
  { id: "happyhours", alignment: "left", label: "Happy Hours" },
  { id: "kidsmenu", alignment: "left", label: "Kids Menu" },
];

function BasicBreadcrumbs() {
  return (
    <div role="presentation">
      <Breadcrumbs aria-label="breadcrumb">
        <Link
          to={"/dashboard/daily_specials"}
          underline="hover"
          color="#000"
          style={{ color: "#410660" }}
        >
          {" "}
          Daily Specials
        </Link>
        <Typography
          color="text.primary"
          style={{ fontWeight: "500", color: "#410660" }}
        >
          KFC
        </Typography>
      </Breadcrumbs>
    </div>
  );
}

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.alignment}
            padding={headCell.disablePadding ? "none" : "default"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <Box>
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : "asc"}
                onClick={createSortHandler(headCell.id)}
                style={{ color: "#969696", fontWeight: 600 }}
              >
                {headCell.label}
              </TableSortLabel>
            </Box>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

let EnhancedTableToolbar = (props) => {
  const { numSelected } = props;
  const [searched, setSearched] = React.useState("");

  return (
    <div
      style={{
        display: "flex",
        // width: "350px",
        alignItems: "center",
        marginLeft: "1rem",
        marginTop: "1rem",
      }}
    >
      <div style={{ width: "30%" }}>
        <SearchBar
          label="Search Daily Specials"
          value={searched}
          onChange={(val) => {
            setSearched(val);
            props.onSearch(val);
          }}
        />
      </div>
    </div>
  );
};

function EnhancedTable({ data, setData, editedData, setEditedData }) {
  const params = useParams();
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("customer");
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [loader, setLoader] = React.useState(false);
  const [fixedData, setFixedData] = React.useState([]);
  const [Refresh, setRefresh] = React.useState(false);
  const [isSwitchEnabled, setIsSwitchEnabled] = useState(false);

  useEffect(() => {
    const getAllHappyHours = async () => {
      try {
        setLoader(true);
        const response = await GetAllDataNestedCollections(
          "Restaurants",
          params.restaurantid,
          "HappyHours"
        );

        


        setData(response);

        setLoader(false);
      } catch (err) {
        console.log(err);
        setLoader(false);
      } finally {
        setLoader(false);
      }
    };

    getAllHappyHours();
  }, []);

  

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = data.map((n) => n.id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const isSelected = (id) => selected.indexOf(id) !== -1;

  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, data.length - page * rowsPerPage);

  const handleSearch = (val) => {
    console.log(val);
    if (!val) {
      setData(fixedData);
      return;
    }
    const filteredRows = fixedData.filter((row) => {
      return row.title?.toLowerCase().includes(val?.toLowerCase());
    });
    console.log(filteredRows);
    setData(filteredRows);
  };
  const history = useNavigate();

  const [open, setOpen] = React.useState(false);

  const [DeleteUid, setDeleteUid] = useState("");
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };


  // ====================
    const handleRowClick = (event, id) => {


  const clickedRow = data.find((row) => row.id === id);
  
  const editedRow = {
    id: id,
    
    day: clickedRow.day,
    status: clickedRow.status,
    fromTime: clickedRow.fromTime,
    toTime: clickedRow.toTime,
  };

  

  
  setEditedData((prevData) => ({
    ...prevData,
    [id]: editedRow,
  }));
};

const handleSwitchChange = (id, newValue, editedData, setEditedData) => {
  const editedRow = {
    ...editedData[id],
    status: newValue ? "Enable" : "Disable",
  };

  setEditedData((prevData) => ({
    ...prevData,
    [id]: editedRow,
  }));
};

const handleTimeChange = (id, newTime, editedData, setEditedData) => {
    const editedRow = {
      ...editedData[id],
      fromTime: newTime.fromTime,
      toTime: newTime.toTime,
    };

    setEditedData((prevData) => ({
      ...prevData,
      [id]: editedRow,
    }));
  };




  return (
    <div>
      {loader ? (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <CircularProgress />
        </div>
      ) : (
        <>
          <Paper
            style={{
              boxShadow: "none !important",
              border: "1px solid rgba(76, 78, 100, 0.25)",
              borderRadius: "10px",
            }}
          >
            <TableContainer style={{ height: "70vh" }}>
              <Table
                aria-labelledby="tableTitle"
                size={"medium"}
                aria-label="enhanced table"
              >
                <TableBody>
                  {stableSort(data, getComparator(order, orderBy))
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => {
                      const isItemSelected = isSelected(row.id);
                      return (
                        <TableRow
                          // onClick={()=>history("/dashboard/add_menu")}
                           onClick={(event) => handleRowClick(event, row?.id)}

                          hover
                          role="checkbox"
                          aria-checked={isItemSelected}
                          tabIndex={-1}
                          key={`${row.id}-${index}`}
                          selected={isItemSelected}
                        >
                          <TableCell align="center" style={{ width: "30%" }}>
                            {" "}
                            <Typography
                              style={{ fontWeight: "600", fontSize: "16px" }}
                            >
                              {row?.day}
                            </Typography>{" "}
                          </TableCell>

                          <TableCell align="center" style={{ width: "30%" }}>
                            {/* <SwitchCheck /> */}
                            <SwitchCheck
                              initialValue={row?.status === "Enable"}
                              onSwitchChange={(newValue) => handleSwitchChange(row.id, newValue, editedData, setEditedData)}
                            />
                          </TableCell>

                          <TableCell align="left" style={{ width: "40%" }}>
                            <TimeRangeField
                              fromTime={row?.fromTime}
                              toTime={row?.toTime}
                              onTimeChange={(newTime)=>handleTimeChange(row?.id, newTime, editedData, setEditedData)}
                            />
                          </TableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={data.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onChangePage={handleChangePage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
            />
          </Paper>

         
        </>
      )}
    </div>
  );
}

const HappyHours = () => {
    const params = useParams()
  let [data, setData] = React.useState([]);
  const [editedData, setEditedData] = useState({});
  const [editHappyHoursLoading, setEditHappyHoursLoading]  = useState(false)

  console.log("editedData")
  console.log(editedData)


// (collection, id, subcollection, subcollectionId, body



const handleSaveHappyHoursDetails = async () => {
  try {
    for (const [happyHoursID, data] of Object.entries(editedData)) {
      setEditHappyHoursLoading(true)
     await UpdateAllDocsNestedCollections("Restaurants", params?.restaurantid, "HappyHours", happyHoursID, data)
     setEditHappyHoursLoading(false)
      console.log(happyHoursID, data)
    }

    setEditedData({});
  } catch (error) {
    console.error("Error saving happy hour details", error);
  }
};


  return (
    <React.Fragment>

      <Grid
        style={{ marginBottom: "10px", alignItems: "center" }}
        justify="space-between"
        container
        // spacing={24}
      >
        <Grid item>
          <Typography
            gutterBottom
            variant="h3"
            display="inline"
            style={{
              fontWeight: "700",
              letteSpacing: "0.2px",
              fontSize: "25px",
            }}
          >
            Happy Hours
          </Typography>
        </Grid>

        <Grid
          style={{
            marginRight: "20px",
          }}
        >
          <ButtonIconComponent
            loader={editHappyHoursLoading}
            name="Save "
            onClick={handleSaveHappyHoursDetails}
            imageBool={false}
          />
        </Grid>
      </Grid>

      <Divider
        style={{
          marginTop: "20px",
          marginBottom: "10px",
          backgroundColor: "#fafafa",
        }}
      />

      <Grid container spacing={6}>
        <Grid item xs={12}>
          <BasicBreadcrumbs />
        </Grid>
      </Grid>

      <Grid container spacing={6}>
        <Grid item xs={12}>
          <EnhancedTable data={data} setData={setData}  editedData={editedData} setEditedData={setEditedData} />
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default HappyHours;
